import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import HeroSection from '../components/PageSections/HeroSection';
import RecognizedSection from '../components/PageSections/RecognizedSection';
import OurServicesSection from '../components/OurServices/OurServicesSection';
import './Home.css';
import SupportForm from '../components/PageSections/SupportForm';
import Testimonials from '../components/Testimonials/Testimonials';
import StudentPrograms from '../components/PageSections/StudentPrograms';
import FAQSection from '../components/PageSections/FAQSection';

function Home() {
  return (
    <div className="home-page">
      <Navbar />
      
      {/* Hero Section */}
       <section className="hero-scroll-wrapper1">
        <div className="hero-sticky1">
          <HeroSection />
        </div>
      </section>

      
      {/* Recognized Section */}
      <RecognizedSection />

      {/* Services Section */}
      <OurServicesSection sectionId="servicesec"/>

      {/* Student Programs Section */}
      <StudentPrograms sectionId="studentsec" />

      {/* Testimonials Section */}
      <Testimonials />

      {/* FAQ Section */}
      <FAQSection />
      
      {/* Support Form Section */}
      <SupportForm />
      {/* Footer */}  
      <Footer />
    </div>
  );
}

export default Home;
